import _ from 'underscore';
import BasicInspectorNodeParamView from "views/audioEditor/sequencerNodeInspectorSection/paramView/BasicInspectorNodeParamView";
import ParagraphParamTemplate from 'text!../../../../../templates/audioEditor/sequencerNodeInspectorSection/paramView/ParagraphParamTemplate.html';


const ParagraphParamView = BasicInspectorNodeParamView.extend({

    constructor : function(attributes, options) {
        BasicInspectorNodeParamView.apply(this, [attributes, options]);
        this.compiledTemlate =  _.template(ParagraphParamTemplate);
    },			
    

    updateViewOnValueChange : function(newValue){
        if(this.textContent$el){
            this.textContent$el.html(newValue);
        }
    },

    render : function(){
        this.$el.html(this.compiledTemlate({ "viewObj": this}));
        this.setElement(this.$el.find(".basic_inpector_param_view").first());
        this.textContent$el = this.$el.find(".paragraph_content");
    }

});
export default ParagraphParamView;